"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcPaginatorBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_dropdown_behavior_1 = require("../bc-dropdown/bc-dropdown-behavior");
var bc_paginator_constants_1 = require("./bc-paginator-constants");
var bc_paginator_constants_2 = require("./bc-paginator-constants");
var bc_paginator_constants_3 = require("./bc-paginator-constants");
var bc_paginator_constants_4 = require("./bc-paginator-constants");
var bc_paginator_constants_5 = require("./bc-paginator-constants");
var bc_paginator_constants_6 = require("./bc-paginator-constants");
var bc_paginator_constants_7 = require("./bc-paginator-constants");
var bc_paginator_constants_8 = require("./bc-paginator-constants");
var bc_paginator_constants_9 = require("./bc-paginator-constants");
var bc_paginator_constants_10 = require("./bc-paginator-constants");
var bc_paginator_constants_11 = require("./bc-paginator-constants");
var bc_paginator_constants_12 = require("./bc-paginator-constants");
var bc_paginator_constants_13 = require("./bc-paginator-constants");
var bc_paginator_constants_14 = require("./bc-paginator-constants");
var bc_paginator_constants_15 = require("./bc-paginator-constants");
var bc_paginator_constants_16 = require("./bc-paginator-constants");
var bc_paginator_constants_17 = require("./bc-paginator-constants");
var bc_paginator_constants_18 = require("./bc-paginator-constants");
var bc_paginator_constants_19 = require("./bc-paginator-constants");
var bc_paginator_constants_20 = require("./bc-paginator-constants");
var bc_paginator_constants_21 = require("./bc-paginator-constants");
var BcPaginatorBehavior = (function (_super) {
    __extends(BcPaginatorBehavior, _super);
    function BcPaginatorBehavior() {
        var _this = _super.call(this) || this;
        _this.paginatorList = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        _this.dropdownPages = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        _this.pagesInfo = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        _this.prev = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        _this.center = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        _this.next = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        _this.currentStart = 0;
        _this.currentPage = 1;
        _this.perPage = bc_paginator_constants_4.PER_PAGE;
        _this.perMultiple = bc_paginator_constants_7.PER_MULTIPLE;
        _this.pageNum = 1;
        return _this;
    }
    BcPaginatorBehavior.setUpAll = function () {
        var paginatorElements = Array.from(document.querySelectorAll("nav[class^='".concat(bc_paginator_constants_1.MOLECULE_PAGINATOR, "']")));
        var elements = [];
        for (var i = 0; i < paginatorElements.length; i++) {
            var element = paginatorElements[i];
            var bcPaginatorBehavior = new BcPaginatorBehavior();
            bcPaginatorBehavior.setElement(element);
            bcPaginatorBehavior.setUp();
            elements.push(bcPaginatorBehavior);
        }
        return elements;
    };
    BcPaginatorBehavior.prototype._setUp = function () {
        _super.prototype._setUp.call(this);
        this.typePaginator = this.mySelf.getAttribute('typepaginator');
        if (this.typePaginator != 'default') {
            this.buildMoleculeAllType();
        }
        else {
            this.buildMoleculeDefaultType();
        }
    };
    BcPaginatorBehavior.prototype.buildMoleculeDefaultType = function () {
        this.paginatorList.classList.add(bc_paginator_constants_10.MOLECULE_PAGINATOR_LIST);
        this.paginatorList.classList.add('default');
        this.mySelf.appendChild(this.paginatorList);
        this.prev.classList.add(bc_paginator_constants_14.MOLECULE_PAGINATOR_PREV);
        this.next.classList.add(bc_paginator_constants_15.MOLECULE_PAGINATOR_NEXT);
        this.addArrowButtonDefault(this.prev, 'arrow2-left', 'Anterior');
        this.addArrowButtonDefault(this.next, 'arrow2-right', 'Siguiente');
        this.paginatorList.insertAdjacentElement('afterbegin', this.prev);
        this.paginatorList.insertAdjacentElement('beforeend', this.next);
        this.prevPage();
        this.nextPage();
    };
    BcPaginatorBehavior.prototype.buildMoleculeAllType = function () {
        this.totalPages = parseInt(this.mySelf.getAttribute('totalregisters'), 10);
        this.idPaginator = this.mySelf.getAttribute('typepaginator');
        this.perPage = parseInt(this.mySelf.getAttribute('perpage'), 10);
        this.perMultiple = parseInt(this.mySelf.getAttribute('multiple'), 10);
        this.paginatorList.classList.add(bc_paginator_constants_10.MOLECULE_PAGINATOR_LIST);
        this.pagesInfo.classList.add(bc_paginator_constants_12.MOLECULE_PAGINATOR_PAGE_INFO);
        this.dropdownPages.classList.add(bc_paginator_constants_11.MOLECULE_PAGINATOR_PAGES);
        if (this.typePaginator === 'full') {
            this.mySelf.appendChild(this.pagesInfo);
        }
        this.mySelf.appendChild(this.paginatorList);
        if (this.typePaginator === 'simple' || this.typePaginator === 'full') {
            this.mySelf.appendChild(this.dropdownPages);
        }
        this.prev.classList.add(bc_paginator_constants_14.MOLECULE_PAGINATOR_PREV);
        this.center.classList.add(bc_paginator_constants_13.MOLECULE_PAGINATOR_CENTER);
        this.next.classList.add(bc_paginator_constants_15.MOLECULE_PAGINATOR_NEXT);
        this.addArrowButton(this.prev, 'arrow2-left');
        this.addArrowButton(this.next, 'arrow2-right');
        this.prevPage();
        this.nextPage();
        this.setperPage(this.dropdownPages);
        this.buildPagination(this.totalPages, this.currentStart, this.perPage);
    };
    BcPaginatorBehavior.prototype.addArrowButton = function (elem, icon) {
        elem.innerHTML = "<button class=\"bc-btn-icon\" aria-label=\"Boton\" tabindex=\"0\">\n  <i class=\"bc-icon bc-sm\" aria-hidden=\"true\" aria-label=\"prueba\" role=\"img\" size=\"md\">".concat(icon, "</i>\n</button>");
    };
    BcPaginatorBehavior.prototype.addArrowButtonDefault = function (elem, icon, text) {
        elem.innerHTML = "<button class=\"bc-btn-icon\" aria-label=\"Boton\" tabindex=\"0\">\n  <i class=\"bc-icon bc-sm\" aria-hidden=\"true\" aria-label=\"prueba\" role=\"img\" size=\"md\">".concat(icon, "</i>\n</button>");
        var arrowButton = elem.getElementsByTagName('button')[0];
        var textContent = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        if (text === 'Anterior') {
            textContent.textContent = text;
            arrowButton.insertAdjacentElement('beforeend', textContent);
        }
        if (text === 'Siguiente') {
            textContent.textContent = text;
            arrowButton.insertAdjacentElement('afterbegin', textContent);
        }
    };
    BcPaginatorBehavior.prototype.pagination = function (totalPages, startNumber, resultPage) {
        if (resultPage === void 0) { resultPage = bc_paginator_constants_3.DEFAULT_PAGE_COUNT; }
        this.validateNumbers(totalPages, startNumber, resultPage);
        var length = Math.ceil(Math.abs(totalPages / resultPage));
        this.currentPage = (startNumber / resultPage) + 1;
        if (length <= bc_paginator_constants_5.MAX_LENGHT) {
            var fullArray = Array.from(Array(length), function (x, index) { return index + 1; });
            return fullArray;
        }
        if (startNumber === 1) {
            this.currentPage = 1;
        }
        return this.pageManagement(this.currentPage, length);
    };
    BcPaginatorBehavior.prototype.pageManagement = function (currentPage, length) {
        var pages = new Array();
        for (var i = 1; i <= length; i++) {
            this.pageAdder(i, currentPage, length, { pages: pages });
        }
        return pages;
    };
    BcPaginatorBehavior.prototype.pageAdder = function (index, currentPage, length, _) {
        if (index === 1) {
            _.pages.push(index);
        }
        if (currentPage === 1 && index === 1) {
            _.pages.push(index + 1);
            _.pages.push('...');
            return;
        }
        if (currentPage === length && index === length) {
            _.pages.push('...');
            _.pages.push(index - 1);
        }
        if (index === length) {
            _.pages.push(index);
            return;
        }
        this.currentPageIndexValidator(currentPage, index, _, length);
        return _;
    };
    BcPaginatorBehavior.prototype.currentPageIndexValidator = function (currentPage, index, _, length) {
        if (currentPage === index && index - 1 === bc_paginator_constants_6.SECOND_PAGE) {
            _.pages.push(index - 1);
        }
        if (currentPage === index && index - 1 > bc_paginator_constants_6.SECOND_PAGE) {
            _.pages.push('...');
            _.pages.push(index - 1);
        }
        if (currentPage === index) {
            _.pages.push(index);
        }
        if (currentPage === index && index + 1 < length) {
            _.pages.push(index + 1);
            _.pages.push('...');
        }
    };
    BcPaginatorBehavior.prototype.validateNumbers = function (totalPages, startNumber, resultPage) {
        var allNumbers = [totalPages, resultPage, startNumber].every(Number.isFinite);
        if (!allNumbers) {
            throw new TypeError('pagination() espera solo numeros finitos como argumentos.');
        }
        if (totalPages <= 0) {
            throw new Error('totalPages debe ser un número mayor que 0.');
        }
        if (resultPage <= 0) {
            throw new Error('resultPage debe se un número mayor que 0.');
        }
        if (startNumber < 0) {
            throw new Error('startNumber debe se un número mayor o igual que 0.');
        }
    };
    BcPaginatorBehavior.prototype.buildPagination = function (totalPages, currentStart, resultPerPage) {
        if (!currentStart) {
            currentStart = 0;
        }
        if (totalPages < 1) {
            throw new Error('No hay resultados');
        }
        this.pageList = this.pagination(totalPages, currentStart, resultPerPage);
        this.paginatorList.appendChild(this.center);
        this.addPagination(resultPerPage);
    };
    BcPaginatorBehavior.prototype.addPagination = function (resultPerPage) {
        for (var i = 0; i < this.pageList.length; i++) {
            this.addPaginationManagement(i, resultPerPage);
        }
    };
    BcPaginatorBehavior.prototype.addPaginationManagement = function (index, resultPerPage) {
        this.pageNum = this.pageList[index];
        if (this.pageNum === '...') {
            var id = (Math.random() * bc_paginator_constants_9.PAGINATOR_MATH_VALUE_1000) / bc_paginator_constants_8.PAGINATOR_MATH_VALUE_100;
            this.addEllipsis(this.center, "ellipsis-".concat(this.idPaginator, "-").concat(id.toFixed(0)), this.pageList[index - 1], this.pageList[index + 1]);
        }
        else {
            var start = (this.pageNum - 1) * resultPerPage;
            if (this.pageNum === this.currentPage) {
                this.isCurrentPage(start);
                return;
            }
            this.addButtons(this.center, this.pageNum);
        }
    };
    BcPaginatorBehavior.prototype.isCurrentPage = function (start) {
        var characterLength = 2;
        if (this.currentPage > 1) {
            this.paginatorList.insertAdjacentElement('afterbegin', this.prev);
        }
        else {
            this.prev.remove();
        }
        if (this.currentPage < this.pageList[this.pageList.length - 1]) {
            if (this.currentPage === 1) {
                start = 0;
            }
            this.paginatorList.insertAdjacentElement('beforeend', this.next);
        }
        else {
            this.next.remove();
        }
        if (String(this.currentPage).length > characterLength) {
            this.center.insertAdjacentHTML('beforeend', "<button class=\"bc-paginator-number-active bc-paginator-large-button\">".concat(this.pageNum, "</button>"));
        }
        else {
            this.center.insertAdjacentHTML('beforeend', "<button class=\"bc-paginator-number-active\">".concat(this.pageNum, "</button>"));
        }
        return start;
    };
    BcPaginatorBehavior.prototype.setperPage = function (dropdownPages) {
        var dropdown = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        var toggle = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        var title = document.createElement(common_constants_1.BcCommonConstants.H6_TAG);
        var icon = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        var content = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        var list = document.createElement(common_constants_1.BcCommonConstants.UL_TAG);
        var oneHundred = 100;
        var oneThousand = 1000;
        var id = (Math.random() * oneThousand) / oneHundred;
        this.setInfo();
        dropdown.classList.add(bc_paginator_constants_16.MOLECULE_DROPDOWN, bc_paginator_constants_17.MOLECULE_DROPDOWN_PERPAGE);
        dropdown.setAttribute('id', "".concat(id.toFixed(0)));
        toggle.classList.add(bc_paginator_constants_18.MOLECULE_DROPDOWN_TOGGLE, "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-").concat(common_constants_1.BcCommonConstants.FLEX), common_constants_1.BcCommonConstants.BC_ALIGN_ITEMS_BASELINE_CLASS, common_constants_1.BcCommonConstants.BC_TEXT_DECORATION_UNDERLINE);
        toggle.setAttribute('aria-controls', "".concat(id.toFixed(0)));
        title.innerHTML = "".concat(this.perPage);
        icon.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_XS_CLASS);
        icon.innerHTML = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
        content.classList.add(bc_paginator_constants_19.MOLECULE_DROPDOWN_CONTENT);
        content.setAttribute('id', "".concat(id.toFixed(0)));
        this.dropdownFor(dropdown, dropdownPages, list);
        content.appendChild(list);
        toggle.appendChild(title);
        toggle.appendChild(icon);
        dropdown.appendChild(toggle);
        dropdown.appendChild(content);
        dropdownPages.appendChild(dropdown);
        this.initDropdown(dropdown);
    };
    BcPaginatorBehavior.prototype.dropdownFor = function (dropdown, dropdownPages, list) {
        var _this = this;
        var _loop_1 = function (i) {
            var item = document.createElement(common_constants_1.BcCommonConstants.LI_TAG);
            var button = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
            item.classList.add(bc_paginator_constants_21.MOLECULE_DROPDOWN_ITEM);
            button.classList.add(common_constants_1.BcCommonConstants.BC_LINK_CLASS);
            button.innerHTML = "".concat(i * this_1.perMultiple);
            button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () { return _this.onClickPerPage(dropdown, dropdownPages, i); });
            item.appendChild(button);
            list.appendChild(item);
        };
        var this_1 = this;
        for (var i = 1; i <= bc_paginator_constants_2.PAGINATOR_MATH_VALUE_6; i++) {
            _loop_1(i);
        }
    };
    BcPaginatorBehavior.prototype.onClickPerPage = function (dropdown, dropdownPages, i) {
        this.perPage = i * this.perMultiple;
        this.currentStart = 0;
        this.pageList = this.pagination(this.totalPages, this.currentStart, this.perPage);
        this.center.innerHTML = '';
        this.addPagination(this.perPage);
        this.setperPage(dropdownPages);
        dropdown.remove();
        this.setInfo();
        this.changeStatus();
    };
    BcPaginatorBehavior.prototype.addEllipsis = function (center, id, startnum, endnum) {
        var _this = this;
        var dropdownId = (Math.random() * bc_paginator_constants_9.PAGINATOR_MATH_VALUE_1000) / bc_paginator_constants_8.PAGINATOR_MATH_VALUE_100;
        var dropdownEllipsis = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        var icon = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        var content = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        var list = document.createElement(common_constants_1.BcCommonConstants.UL_TAG);
        dropdownEllipsis.classList.add(bc_paginator_constants_16.MOLECULE_DROPDOWN, bc_paginator_constants_20.MOLECULE_DROPDOWN_CUSTOM);
        dropdownEllipsis.setAttribute('id', "".concat(dropdownId.toFixed(0)));
        icon.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_XL_CLASS, bc_paginator_constants_18.MOLECULE_DROPDOWN_TOGGLE);
        icon.setAttribute('aria-controls', id);
        icon.innerHTML = 'secondary-menu-horizontal';
        content.classList.add(bc_paginator_constants_19.MOLECULE_DROPDOWN_CONTENT);
        content.setAttribute('id', id);
        var _loop_2 = function (i) {
            var item = document.createElement(common_constants_1.BcCommonConstants.LI_TAG);
            var button = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
            item.classList.add(bc_paginator_constants_21.MOLECULE_DROPDOWN_ITEM);
            button.classList.add(common_constants_1.BcCommonConstants.BC_LINK_CLASS);
            button.innerHTML = "".concat(i);
            button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () { return _this.onClickAddEllipsis(center, i); });
            item.appendChild(button);
            list.appendChild(item);
        };
        for (var i = startnum + 1; i < endnum; i++) {
            _loop_2(i);
        }
        content.appendChild(list);
        dropdownEllipsis.appendChild(icon);
        dropdownEllipsis.appendChild(content);
        center.insertAdjacentElement('beforeend', dropdownEllipsis);
        this.initDropdown(dropdownEllipsis);
    };
    BcPaginatorBehavior.prototype.onClickAddEllipsis = function (center, i) {
        this.currentStart = (i - 1) * this.perPage;
        this.currentPage = this.currentStart / this.perPage + 1;
        this.pageList = this.pagination(this.totalPages, this.currentStart, this.perPage);
        center.innerHTML = '';
        this.addPagination(this.perPage);
        this.setInfo();
        this.changeStatus();
    };
    BcPaginatorBehavior.prototype.initDropdown = function (dropdown) {
        var config = {
            isPopUp: true,
        };
        this.bcDropdownBehavior = new bc_dropdown_behavior_1.BcDropdownBehavior();
        this.bcDropdownBehavior.setElement(dropdown);
        this.bcDropdownBehavior.setConfig(config);
        this.bcDropdownBehavior.setUp();
    };
    BcPaginatorBehavior.prototype.addButtons = function (center, pageNum) {
        var _this = this;
        var numButtom = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        numButtom.textContent = "".concat(pageNum);
        numButtom.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () { return _this.onClickAddButtons(center, pageNum); });
        center.insertAdjacentElement('beforeend', numButtom);
    };
    BcPaginatorBehavior.prototype.onClickAddButtons = function (center, pageNum) {
        this.currentStart = (pageNum - 1) * this.perPage;
        this.currentPage = this.currentStart / this.perPage + 1;
        this.pageList = this.pagination(this.totalPages, this.currentStart, this.perPage);
        center.innerHTML = '';
        this.addPagination(this.perPage);
        this.setInfo();
        this.changeStatus();
    };
    BcPaginatorBehavior.prototype.prevPage = function () {
        var _this = this;
        this.prev.children[0].addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () { return _this.onClickPrevPage(); });
    };
    BcPaginatorBehavior.prototype.onClickPrevPage = function () {
        if (this.typePaginator != 'default') {
            this.currentPage--;
            if (this.currentStart >= 0) {
                this.currentStart = this.currentStart - this.perPage;
                this.pageList = this.pagination(this.totalPages, this.currentStart, this.perPage);
                this.center.innerHTML = '';
                this.addPagination(this.perPage);
                this.setInfo();
            }
            this.changeStatus();
        }
        else {
            this.changeStatusDefault('previous');
        }
    };
    BcPaginatorBehavior.prototype.nextPage = function () {
        var _this = this;
        this.next.children[0].addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () { return _this.onClickNextPage(); });
    };
    BcPaginatorBehavior.prototype.onClickNextPage = function () {
        if (this.typePaginator != 'default') {
            this.currentPage++;
            if (this.currentStart - this.perPage <= this.totalPages - this.perPage) {
                this.currentStart = this.currentStart + this.perPage;
                this.pageList = this.pagination(this.totalPages, this.currentStart, this.perPage);
                this.center.innerHTML = '';
                this.addPagination(this.perPage);
                this.setInfo();
            }
            this.changeStatus();
        }
        else {
            this.changeStatusDefault('next');
        }
    };
    BcPaginatorBehavior.prototype.setInfo = function () {
        var info = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        info.innerHTML = "Mostrando ".concat(this.getQuantityInfo(), " de ").concat(this.totalPages);
        this.pagesInfo.innerHTML = '';
        this.pagesInfo.appendChild(info);
    };
    BcPaginatorBehavior.prototype.getQuantityInfo = function () {
        var currentItems = this.currentPage * this.perPage;
        if (currentItems > this.totalPages) {
            return this.totalPages;
        }
        else {
            return currentItems;
        }
    };
    BcPaginatorBehavior.prototype.changeStatus = function () {
        this.changeState({
            TotalRegisters: this.totalPages,
            CurrentPage: this.currentPage,
            PerPage: this.perPage,
        });
    };
    BcPaginatorBehavior.prototype.changeStatusDefault = function (text) {
        var previous = false;
        var next = false;
        if (text === 'previous') {
            previous = true;
        }
        if (text === 'next') {
            next = true;
        }
        this.changeState({
            PreviousPage: previous,
            NextPage: next,
        });
    };
    BcPaginatorBehavior.prototype.pairPaginator = function (pair) {
        this.pairPaginatorPrev(pair);
        this.pairPaginatorNext(pair);
        this.pairPaginatorPages(pair);
        this.pairPaginatorDropdwon(pair);
    };
    BcPaginatorBehavior.prototype.pairPaginatorPrev = function (pair) {
        var _this = this;
        this.prev.children[0].addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            pair.onClickPrevPage();
        });
        pair.prev.children[0].addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.onClickPrevPage();
        });
    };
    BcPaginatorBehavior.prototype.pairPaginatorNext = function (pair) {
        var _this = this;
        this.next.children[0].addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            pair.onClickNextPage();
        });
        pair.next.children[0].addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.onClickNextPage();
        });
    };
    BcPaginatorBehavior.prototype.pairPaginatorPages = function (pair) {
        var _this = this;
        this.paginatorList.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            pair.onClickAddButtons(pair.center, _this.currentPage);
        });
        pair.paginatorList.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.onClickAddButtons(_this.center, pair.currentPage);
        });
    };
    BcPaginatorBehavior.prototype.pairPaginatorDropdwon = function (pair) {
        var _this = this;
        this.dropdownPages.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            var page = pair.dropdownPages.querySelector(common_constants_1.BcCommonConstants.H6_TAG);
            pair.perPage = _this.perPage;
            pair.currentStart = _this.currentStart;
            pair.pageList = pair.pagination(_this.totalPages, _this.currentStart, _this.perPage);
            pair.center.innerHTML = '';
            if (page) {
                page.textContent = "".concat(pair.perPage);
            }
            pair.addPagination(pair.perPage);
            pair.setInfo();
            pair.changeStatus();
        });
        pair.dropdownPages.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            var page = _this.dropdownPages.querySelector(common_constants_1.BcCommonConstants.H6_TAG);
            _this.perPage = pair.perPage;
            _this.currentStart = pair.currentStart;
            _this.pageList = _this.pagination(pair.totalPages, pair.currentStart, pair.perPage);
            _this.center.innerHTML = '';
            if (page) {
                page.textContent = "".concat(_this.perPage);
            }
            _this.addPagination(_this.perPage);
            _this.setInfo();
            _this.changeStatus();
        });
    };
    BcPaginatorBehavior.prototype.getPaginatorList = function () {
        return this.paginatorList;
    };
    return BcPaginatorBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcPaginatorBehavior = BcPaginatorBehavior;
